module.exports = __webpack_public_path__ + "static/orangecyberdefense-5cdde372b400d31b353d978e0519477e.png";